const ENLogin = {
	"Acessar Scoreplan": "Access Scoreplan",
	"Autenticado com sucesso": "Successfully authenticated",
	"Empresa padrao está inativada": "Standar company was inactivated",
	"Entrar com a Microsoft": "Sign in with Microsoft",
	"Erro ao efetuar login neste domínio": "Error logging in to this domain",
	"Esqueci minha senha": "Forgot my password",
	"e resultado": "and result",
	"execução": "execution",
	"Lembrar-me": "Remember-me",
	"O sistema mais completo do mercado": "The most complete system on the market",
	"para o Planejamento Estratégico e Orçamentário das Empresas": "for Strategic and Budget Planning for Companies",
	"Planejamento": "Planning",
	"Senha é obrigatório": "Password is required",
	"Usuário/E-mail": "User/E-mail",
	"Usuário/E-mail é obrigatório": "User/E-mail is required",
	"Você não está inserido em nenhuma empresa": "You are not included in any company" 
};

export default ENLogin;
